import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js";

// Connects to data-controller="create-listing-from-product-category"
export default class extends Controller {
  static outlets = ["polaris-autocomplete", "polaris-button"];
  static targets = ["productCategoryGidField", "titleField"];
  static values = { productCategoryGid: String, title: String };

  titleFieldTargetConnected(target) {
    target.addEventListener("input", this.onTitleInputChanged);
  }

  productCategoryGidFieldTargetConnected(target) {
    target.addEventListener(
      "polaris-autocomplete:change",
      this.onProductCategoryChanged,
    );

    this.polarisAutocompleteOutlet.inputTarget.addEventListener(
      "input",
      this.onProductCategoryInputChanged,
    );

    this.polarisAutocompleteOutlet.inputTarget.addEventListener(
      "blur",
      this.onProductCategoryInputBlurred,
    );
  }

  productIdFieldTargetDisconnected(target) {
    target.removeEventListener(
      "polaris-autocomplete:change",
      this.onProductCategoryChanged,
    );
    if (this.hasPolarisAutocompleteOutlet) {
      this.polarisAutocompleteOutlet.inputTarget.removeEventListener(
        "input",
        this.onProductCategoryInputChanged,
      );
      this.polarisAutocompleteOutlet.inputTarget.removeEventListener(
        "blur",
        this.onProductCategoryInputBlurred,
      );
    }
  }

  onProductCategoryChanged = (eventData) => {
    const productCategoryGid = eventData.detail.value;
    this.productCategoryGidValue = productCategoryGid;

    if (this.productCategoryGidValue && Boolean(this.titleValue)) {
      this.continueButtonOutlet.enable();
    } else {
      this.continueButtonOutlet.disableWithoutLoader();
    }
  };

  onTitleInputChanged = (event) => {
    this.titleValue = event.target.value;

    if (Boolean(this.titleValue) && Boolean(this.productCategoryGidValue)) {
      this.continueButtonOutlet.enable();
    } else {
      this.continueButtonOutlet.disableWithoutLoader(event);
    }
  };

  onProductCategoryInputChanged = (event) => {
    if (event.target.value === "") {
      const autocompleteOutlet = this.polarisAutocompleteOutlet;

      if (autocompleteOutlet) {
        if (autocompleteOutlet.hasHiddenInputTarget) {
          autocompleteOutlet.hiddenInputTarget.value = "";
        }
        if (autocompleteOutlet.hasInputTarget) {
          autocompleteOutlet.inputTarget.value = "";
        }

        autocompleteOutlet.reset();
      }

      this.continueButtonOutlet.disableWithoutLoader(event);
    }
  };

  onProductCategoryInputBlurred = (event) => {
    const autocompleteOutlet = this.polarisAutocompleteOutlet;

    const selectedValue = autocompleteOutlet.hiddenInputTarget.value;

    const selectedOption = autocompleteOutlet.visibleOptions.find((option) => {
      const input = option.querySelector("input");

      return input.value === selectedValue;
    });

    if (selectedOption) {
      if (event.target.value !== selectedOption.dataset.label) {
        event.target.value = selectedOption.dataset.label;
      }
    }
  };

  handleSubmit(event) {
    this.continueButtonOutlet.disable(event);

    get(
      `/retailer/product_listings/new?product_category_gid=${this.productCategoryGidValue}&title=${this.titleValue}`,
      {
        responseKind: "turbo-stream",
      },
    );
  }

  get continueButtonOutlet() {
    return this.polarisButtonOutlets.find(
      (outlet) => outlet.element.id === "continue-button",
    );
  }
}
